<template>
    <section class="confirm-order-modal">
        <v-row justify="center" align="center">
         <v-dialog v-model="this.$store.state.isconfirmOrderOpen" persistent max-width="90%">
         <v-form v-model="valid">
          <v-card class="pb-6">
           <v-card-title class="text-center"><span class="heading">Confirm your order</span></v-card-title>
           <v-card-text>
             <v-container>
              <p class="pr-6 pl-6">total price <span class="float-right">22$</span></p>
               <div>
                <v-radio-group v-model="paymentMethode" row>
                 <v-radio :label="$t('formes.labels.confirmOreds.payOnline')" value="onlinePayment"></v-radio>
                 <v-radio :label="$t('formes.labels.confirmOreds.pay')" value="DeliveryPayment"></v-radio>
                </v-radio-group>
               </div>
               <div class="pyment-methods" v-if="paymentMethode=='onlinePayment'">
                <v-select class="mt-3 mb-3" :items="pymentMethods"  :label="$t('formes.labels.confirmOreds.paymentMethodes')"  hide-details="auto"
                prepend-icon="fa fa-bank" ></v-select>
                <v-text-field type="email" :label="$t('formes.labels.email')" :rules="rules" hide-details="auto"
                 prepend-icon="fa fa-phone" ></v-text-field>
               </div>
               <div class="adress mt-8">
                  <v-text-field :label="$t('formes.labels.confirmOreds.adress')" :outlined="false"  hide-details="auto"
                  :counter="50" required
                ></v-text-field>
               </div>
             </v-container>
           </v-card-text>
           <v-card-actions>
           <v-spacer></v-spacer>
            <v-btn color="black" :outlined='true' dark @click="closeConfirmDialog()">close</v-btn>
            <v-btn color="red" dark >confirm order</v-btn>
           </v-card-actions>
          </v-card>
         </v-form>
         </v-dialog>
        </v-row>
    </section>
</template>

<script>
export default {
    name:'confirm',
    data() {
        return {
            valid:true,
            paymentMethode:'onlinePayment',
            dialog:true,
            pymentMethods:['paypal','visa cart','payouner'],
            rules: [
                    value => !!value || 'Required.',
                    value => (value && value.length >= 3) || 'Min 3 characters',
            ]
        }
    },
    methods:{
        closeConfirmDialog(){
            this.$store.state.isconfirmOrderOpen=false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .pyment-methods{
        border: 1px solid #000;
        padding: 9px 20px 32px 30px;
        margin-left: 33%;
    }
</style>